import { GQL_ID } from '@@types'

import type { MainPageBlock } from '@entities/MainPageConfig'

import BannerBlock from '@features/main-page-builder/ui/blocks/BannerBlock'
import BannerGalleryBlock from '@features/main-page-builder/ui/blocks/BannerGalleryBlock'
import CategoriesBlock from '@features/main-page-builder/ui/blocks/CategoriesBlock'
import CouponsBlock from '@features/main-page-builder/ui/blocks/CouponsBlock'
import CustomBlock from '@features/main-page-builder/ui/blocks/CustomBlock'
import LoyaltyLevelBlock from '@features/main-page-builder/ui/blocks/LoyaltyLevelBlock'
import MenuBlock from '@features/main-page-builder/ui/blocks/MenuBlock'
import PersonalOffersBlock from '@features/main-page-builder/ui/blocks/PersonalOffersBlock'
import ProductsBlock from '@features/main-page-builder/ui/blocks/ProductsBlock'
import TextMaterialsBlock from '@features/main-page-builder/ui/blocks/TextMaterialsBlock'

export interface BlockProps {
  block: MainPageBlock;
  payload: Record<string, unknown> | null;
  shopId: GQL_ID;
}

export const blockComponents: Record<string, React.FC<BlockProps>> = {
  banner: BannerBlock,
  bannerGallery: BannerGalleryBlock,
  products: ProductsBlock,
  categories: CategoriesBlock,
  textMaterials: TextMaterialsBlock,
  menu: MenuBlock,
  personalOffers: PersonalOffersBlock,
  coupons: CouponsBlock,
  loyaltyLevel: LoyaltyLevelBlock,
  custom: CustomBlock,
}

export type BlockType = keyof typeof blockComponents;